import React from 'react';
import {useTranslation} from 'react-i18next';
import Svg, {Path} from 'react-native-svg';
import theme from '@/style';
import {goSmartCS} from '@/utils';

const withAlpha = (color: string, alpha: number) => {
  if (/^#([0-9a-f]{6})$/i.test(color)) {
    const hex = color.replace('#', '');
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  return color;
};

const CustomerServiceIcon = ({color}: {color: string}) => {
  return (
    <Svg width={16} height={16} viewBox="0 0 16 16" fill="none">
      <Path
        d="M3.333 11.333H2.667A1.333 1.333 0 0 1 1.333 10V3.333A1.333 1.333 0 0 1 2.667 2h10.666a1.333 1.333 0 0 1 1.334 1.333V10a1.333 1.333 0 0 1-1.334 1.333H7.333L4.667 14v-2.667H3.333Z"
        stroke={color}
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M5.333 5.333H10.667"
        stroke={color}
        strokeWidth={1.4}
        strokeLinecap="round"
      />
      <Path
        d="M5.333 8H8.667"
        stroke={color}
        strokeWidth={1.4}
        strokeLinecap="round"
      />
    </Svg>
  );
};

const CustomerServiceEntry = ({
  orderNo,
  type,
}: {
  orderNo?: string;
  type: '1' | '2';
}) => {
  const {i18n} = useTranslation();

  return (
    <button
      type="button"
      onClick={() => {
        goSmartCS({
          type,
          orderNo,
        });
      }}
      className="w-full h-[38px] rounded-[8px] border-0 p-0 flex items-center justify-center cursor-pointer"
      style={{
        backgroundColor:
          theme.basicColor.lightPrimary ||
          withAlpha(theme.basicColor.primary, 0.08),
      }}>
      <span className="inline-flex items-end gap-2 leading-none">
        <span className="shrink-0">
          <CustomerServiceIcon color={theme.basicColor.primary} />
        </span>
        <span
          className="text-[14px] font-medium leading-[normal] whitespace-nowrap"
          style={{color: theme.basicColor.primary}}>
          {i18n.t('me.bottom.contactCustomer')}
        </span>
      </span>
    </button>
  );
};

export default CustomerServiceEntry;
